import { useEffect, useState } from 'react';

// Service
import BranchService from '../../services/branchService';

const initFilter = {
    pageNumber: 1,
    pageSize: 10,
    active: true,
    textFilter: null,
    businessId: 0,
    country: null,
    onlyData: false
}

const useSearchBranches = () => {
    const [searchResult, setSearchRestul] = useState({
        branches: [],
        totalPages: 0,
        totalResults: 0
    });
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState(initFilter);

    useEffect(() => {
        const SearchBranches = () => {
            setLoading(true);
            BranchService
                .Search(filters)
                .then(res => setSearchRestul({
                    branches: res.values,
                    totalPages: res.totalPages,
                    totalResults: res.totalResults
                }))
                .finally(() => setLoading(false));
        }

        if (filters.businessId > 0 || filters.country)
            SearchBranches();
    }, [filters])

    return {
        ...searchResult,
        loading,
        filters,
        setFilters
    }
}

export default useSearchBranches;